(function () {
  function onKeyDown(e) {
    if (e.key === "Tab") {
      document.documentElement.classList.add("user-is-tabbing");
      window.removeEventListener("keydown", onKeyDown);
    }
  }

  function onPointer() {
    document.documentElement.classList.remove("user-is-tabbing");
    window.addEventListener("keydown", onKeyDown);
  }

  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("mousedown", onPointer);
  window.addEventListener("touchstart", onPointer, { passive: true });
})();

(function () {
  var dialog = document.getElementById("HomepageDailyDialog");
  if (!dialog) return;

  // Key is per store domain, so it won’t clash if you duplicate themes / environments
  var KEY = "homepage_daily_dialog_last_shown__" + window.location.host;

  function getLocalYMD() {
    var d = new Date(); // visitor’s local time
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, "0");
    var day = String(d.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + day;
  }

  function openDialog(d) {
    if (typeof d.showModal === "function") {
      try { d.showModal(); }
      catch (e) { d.setAttribute("open", "open"); }
    } else {
      d.setAttribute("open", "open");
    }
  }


  function closeDialog(d) {
    if (typeof d.close === "function") d.close();
    else d.removeAttribute("open");
  }

  var today = getLocalYMD();
  var last = window.sessionStorage.getItem(KEY);

  if (last !== today) {
    openDialog(dialog);
    var focusTarget = dialog.querySelector(".homepage-daily-dialog__inner");
    setTimeout(function () {
      if (!focusTarget) return;
      try { focusTarget.focus({ preventScroll: true }); }
      catch (e) { focusTarget.focus(); }
    }, 0);
    window.sessionStorage.setItem(KEY, today);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-modal-close]")) closeDialog(dialog);
  });
})();
